<template>
<div>
  <main-header-mobile />
  <main-header />
  <main-vedio />
  <main-info />
</div>
</template>

<script>
import MainHeader from '@/components/main-header.vue';
import MainHeaderMobile from '@/components/main-header-mobile.vue';
import MainInfo from '@/components/main-info.vue';
import MainVedio from './components/main-vedio.vue';

export default {
  components: {
    MainHeader,
    MainHeaderMobile,
    // MainStart,
    MainInfo,
    MainVedio,
  },
  name: 'App',
};
</script>

<style lang="less">
.mobile {
  display: none;
}
@media screen and (max-width: 870px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
}
img {
  display: block;
}
html {
  background-size: 1920px;
}
body {
  margin: 0;
}
body,
div,
span,
header,
section,
nav,
a,
p,
h1,
h2,
h3,
h4,
h5 {
  box-sizing: border-box;
}
.anim-item-floating {
  animation-name: floating;
  animation-duration: 8s;
  animation-timing-function: ease;
  animation-delay: 1s;
  animation-iteration-count: infinite;
  transform-style: "preserve-3d";
}
@keyframes floating {
  0% {
    transform: translate(0);
  }

  25% {
    transform: translateY(20px);
  }

  50% {
    transform: translate(0);
  }

  75% {
    transform: translateY(20px);
  }

  to {
    transform: translate(0);
  }
}
</style>
